import BasicTextInput from "components/BasicInputs/BasicTextInput";
import { useFormikContext } from "formik";
import useCurrency from "helpers/useCurrency";
import { useEffect } from "react";
import { calculateRowTotalPrice } from "components/production/order/utils";

export default function TotalPrice({ row }: { row: MaterialOrderRow }) {
  const data = useFormikContext<MaterialOrderData>();
  const { defCur } = useCurrency();
  const v = data.values;

  useEffect(() => {
    let totalPrice: number;
    if (row.selectedUnit === row.subUnit) {
      totalPrice = calculateRowTotalPrice(row.unitPrice, row.quantity, row.conversionRatio);
    } else {
      totalPrice = calculateRowTotalPrice(row.unitPrice, row.quantity, undefined);
    }

    const newRows = [...(v.materialsRows || [])];
    const index = newRows.findIndex((x) => x.ind === row.ind);
    if (index > -1) {
      newRows[index] = { ...row, totalPrice: totalPrice };
      data.setFieldValue("materialsRows", newRows);
    }
  }, [row.unitPrice, row.selectedUnit, row.subUnit, row.conversionRatio, row.quantity]);

  return (
    <BasicTextInput
      type="price"
      arrowHidden
      style={{ padding: "0px 12px 0px 0px" }}
      val={row.totalPrice}
      disabled
      prefix={
        <div className="px-4 border-r border-slate-300 text-[#6B7888]">
          <div>{defCur.en_title}</div>
        </div>
      }
    />
  );
}
